module.exports = __webpack_public_path__ + "img/service3.15eb8477.jpg";